import React, { memo } from 'react';
import * as S from './style';

interface IProps {
  children?: React.ReactNode;
}

const FltBrandBox = ({ children }: IProps) => (
  <S.FltBrandBox>{children}</S.FltBrandBox>
);

export default memo(FltBrandBox);
